import modelBaseV2 from "../../model-base-v2.model";

export const hhpDistyCoverageDownloadParamsMapping = {
  SellthruCoverage: {
    name: "SellthruCoverage",
    storedProcedureCode: "57",
    params: {
      pageIndex: "3",
      pageSize: "4",
      fromDate: "8",
      toDate: "9",
      isExcelDownload: "79",
      dateType: "120",
      modelAliases: "127",
      coverageType: "128",
    }
  },
  SellthruCoverageRaw: {
    name: "SellthruCoverageRaw",
    storedProcedureCode: "64",
    params: {
      fromDate: "8",
      toDate: "9",
      dateType: "120",
      modelAliases: "127",
    }
  },
  SellthruRaw: {
    name: "SellthruRaw",
    storedProcedureCode: "65",
    params: {
      fromDate: "8",
      toDate: "9",
      dateType: "120",
      modelAliases: "127",
    }
  },
  SellthruCoverageDetail: {
    name: "SellthruCoverageDetail",
    storedProcedureCode: "58",
    params: {
      pageIndex: "3",
      pageSize: "4",
      fromDate: "8",
      toDate: "9",
      isExcelDownload: "79",
      dateType: "120",
      distyCode: "121",
      modelAliases: "127",
      coverageType: "128",
    }
  },
}

const HHPDistyCoverageModel = {
  searchHHPDistyCoverage: (body) => {
    return modelBaseV2.post('/api/hhp-disty-coverage/coverage', { body });
  },
  getHHPDistyCoverageDetail: (body) => {
    return modelBaseV2.post('/api/hhp-disty-coverage/details', { body });
  },
  downloadHHPDistyCoverage: (type = '', body, excelSheetNames = [''], fileName = '') => {
    const downloadConfig = hhpDistyCoverageDownloadParamsMapping[type]
    const params = Object.entries(downloadConfig.params).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames,
      storedProcedureCode: downloadConfig.storedProcedureCode,
      params
    }
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: exportConfig }, `${fileName}_${body.fromDate}_${body.toDate}.xlsx`);
  }
}

export default HHPDistyCoverageModel;  